const nestApi = process.env.REACT_APP_NEST_API_URL;

//* 파트너 관리
export const userPartner = `${nestApi}/user-payback-partner`;

//* 파트너 혜택 조회
export const userPartnerBenefit = `${nestApi}/user-payback-partner-benefit`;

//* 내 파트너 조회
export const userPartnerConnection = `${nestApi}/user-payback-partner-connection`;

//* 계좌정보 등록
export const userBankAccount = `${nestApi}/user-payback-partner-account`;

//* 은행 리스트
export const bankList = `${nestApi}/v1/user-payback-partner-account/banks`;

//* 파트너 검색 리스트
export const partnerSearchList = `${nestApi}/user/join/search-partner`;
export const partnerSearchListV2 = `${nestApi}/v2/user/join/search-partner`;
